import { render, staticRenderFns } from "./hoverableCard.vue?vue&type=template&id=34bbea36&scoped=true&"
import script from "./hoverableCard.vue?vue&type=script&lang=js&"
export * from "./hoverableCard.vue?vue&type=script&lang=js&"
import style0 from "./hoverableCard.vue?vue&type=style&index=0&id=34bbea36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbea36",
  null
  
)

export default component.exports